import React from "react";

type MagicIconProps = React.SVGProps<SVGSVGElement>;

export const MagicIcon: React.FC<MagicIconProps> = (props) => (
  <svg
    aria-label="Magic icon"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="currentColor"
    role="img"
    {...props}
  >
    <path d="M10 5.5l1.2 3.2 3.2 1.2-3.2 1.2L10 14.5l-1.2-3.2-3.2-1.2 3.2-1.2L10 5.5z" />
    <path d="M5.4 2.8l0.5 1.3 1.3 0.5-1.3 0.5-0.5 1.3-0.5-1.3-1.3-0.5 1.3-0.5 0.5-1.3z" />
    <path d="M6.2 13.8l0.4 1 1 0.4-1 0.4-0.4 1-0.4-1-1-0.4 1-0.4 0.4-1z" />
  </svg>
);

export default MagicIcon;
